import { useState } from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Calendar, Loader } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import Input from './ui/Input';

const CompleteProfilePage = () => {
    const [degree, setDegree] = useState('');
    const [gradYear, setGradYear] = useState('');
    const { completeProfile, error, isLoading } = useAuthStore();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await completeProfile(degree, gradYear);
            navigate('/');
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div className="flex justify-center font-libre items-center min-h-screen px-4 py-6 sm:py-12">
            <div className="area">
                <ul className="circles">
                    {Array.from({ length: 10 }).map((_, i) => (<li key={i}></li>))}
                </ul>
            </div>
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className='w-full max-w-md bg-gray-800 bg-opacity-50 backdrop-filter backdrop-blur-xl rounded-2xl shadow-xl overflow-hidden'
            >
                <div className='p-6 sm:p-8'>
                    <h2 className='text-2xl sm:text-3xl font-bold text-center bg-purple-400 text-transparent bg-clip-text mb-2'>
                        Complete Your Profile
                    </h2>
                    <p className='text-gray-400 text-sm text-center mb-6'>
                        Just two more details to finish setting up your account
                    </p>

                    <form onSubmit={handleSubmit}>
                        {/* Degree */}
                        <div className='relative mb-6'>
                            <div className='absolute inset-y-0 left-0 flex items-center pl-3 z-10 pointer-events-none'>
                                <GraduationCap className='size-5 text-purple-500' />
                            </div>
                            <select
                                value={degree}
                                onChange={(e) => setDegree(e.target.value)}
                                required
                                className='w-full pl-10 pr-8 py-2 bg-gray-800 bg-opacity-50 rounded-lg border
                                    border-gray-700 focus:border-purple-500 focus:ring-2 focus:ring-purple-500
                                    text-gray-400 transition duration-200 appearance-none'
                            >
                                <option value="" disabled className='bg-gray-800'>Select Degree</option>
                                <option value="B.Tech" className='text-white bg-gray-800'>B.Tech</option>
                                <option value="M.Tech" className='text-white bg-gray-800'>M.Tech</option>
                            </select>
                            <div className='absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none'>
                                <svg className='h-4 w-4 text-purple-500' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M19 9l-7 7-7-7' />
                                </svg>
                            </div>
                        </div>

                        {/* Graduation Year */}
                        <Input
                            icon={Calendar}
                            type='number'
                            placeholder='Graduation Year (e.g. 2026)'
                            label='Graduation Year'
                            value={gradYear}
                            onChange={(e) => setGradYear(e.target.value)}
                        />

                        {error && (
                            <p className='text-red-500 text-sm font-semibold mt-2'>{error}</p>
                        )}

                        <motion.button
                            className='w-full mt-2 py-2.5 sm:py-3 px-4 bg-gradient-to-r from-purple-500
                                to-indigo-600 text-white font-bold rounded-lg shadow-lg hover:from-purple-600
                                hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-purple-500
                                focus:ring-offset-2 focus:ring-offset-gray-900 transition duration-200 text-sm sm:text-base'
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            type='submit'
                            disabled={isLoading}
                        >
                            {isLoading
                                ? <Loader className='animate-spin mx-auto size-5 sm:size-6' />
                                : 'Save & Continue'
                            }
                        </motion.button>
                    </form>
                </div>
            </motion.div>
        </div>
    );
};

export default CompleteProfilePage;